import { render, staticRenderFns } from "./BaseCustomerDisplay.vue?vue&type=template&id=f6d9317e"
import script from "./BaseCustomerDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCustomerDisplay.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports